//@ts-nocheck
import request from '../../../services/request';

export const getTripData = (tripId = '', tripKey = '') => {
  return request
    .get(`trips/${tripId}/app?tripKey=${tripKey}`)
    .then((res) => res);
};

export const getAppManifest = (tripId = '') => {
  return request.get(`trips/${tripId}/appmanifest`).then((res) => res);
};
